import { render } from "./OffcanvasFilter.vue?vue&type=template&id=47f549c4&scoped=true"
import script from "./OffcanvasFilter.vue?vue&type=script&lang=js"
export * from "./OffcanvasFilter.vue?vue&type=script&lang=js"

import "./OffcanvasFilter.vue?vue&type=style&index=0&id=47f549c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f549c4"]])

export default __exports__